import type { Hydratable } from '@vimcar/mvvm/hydratable'

import * as dataMapper from '@vimcar/mvvm/dataMapper'
import hydratable from '@vimcar/mvvm/hydratable'
import * as mobx from 'mobx'

import type { Nodes, ContentType, NodeTypes } from '../'
import type { CustomNode } from '../CustomNode'
import type { SelectNode } from '../SelectNode'
import type { ValuedNode } from '../ValuedNode'

type _NodeLink = {
  id: string
  title: string
  text: string
  subtext: string
  preSelected: boolean
  highlighted: boolean
  alwaysShow?: boolean
  keywords?: Array<string>
  externalLink?: string
  _link: { sys: { id: string } }
  contentModelType: ContentType
  link: SelectNode | ValuedNode | CustomNode
  matches: (string) => boolean
}

// @ts-expect-error@2314
export type NodeLink = Hydratable<_NodeLink, object>

type Options = { nodes: Nodes }

const mkNodeLink = hydratable(
  ({ nodes }: Options) => {
    const nodeLink = mobx.observable({
      contentModelType: 'selectNodeLink',
      get link() {
        return nodeLink._link && nodes.get(nodeLink._link.sys.id)
      },
      matches: (term) => {
        const cleanIncludes = (container, e) =>
          container.toUpperCase().includes(e.toUpperCase())

        return (
          nodeLink.alwaysShow ||
          (nodeLink.text && cleanIncludes(nodeLink.text, term)) ||
          (nodeLink.subtext && cleanIncludes(nodeLink.subtext, term)) ||
          (nodeLink.keywords &&
            nodeLink.keywords.length &&
            nodeLink.keywords.some((keyword) => cleanIncludes(keyword, term)))
        )
      },
    } as _NodeLink)
    return nodeLink
  },
  'NodeLink',
  {
    fields: dataMapper.lift({
      link: '_link',
    }),
    sys: dataMapper.lift({
      id: true,
    }),
  },
)

export default mkNodeLink
